import React from "react";

export default function FormsAndTemplates() {
  return <div>FormsAndTemplates</div>;
}
